/**
 * Homepage – the main landing page.
 * Assembles the full-screen hero slideshow, interactive vinyl turntable player,
 * and site footer. Injects MusicGroup JSON-LD structured data for SEO.
 */
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import VinylPlayerSection from "@/components/VinylPlayerSection";
import Footer from "@/components/Footer";
import GrainOverlay from "@/components/GrainOverlay";
import PageFrame from "@/components/PageFrame";
import useJsonLd from "@/hooks/useJsonLd";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const Index = () => {
  useDocumentMeta({
    title: "Thursday Jam – Blues Rock Band from Berlin, Germany",
    description: "Thursday Jam is a Berlin-based family band playing soulful blues rock rooted in classic guitar music. Listen to original tracks, watch live footage, and explore the story behind the music.",
    canonical: "https://thursdayjam.rocks",
    ogImage: "/images/og-hero.jpg",
  });

  useJsonLd({
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    name: "Thursday Jam",
    url: "https://thursdayjam.rocks",
    image: "https://thursdayjam.rocks/images/og-hero.jpg",
    genre: ["Blues Rock", "Classic Rock", "Melodic Rock"],
    foundingDate: "2018",
    foundingLocation: {
      "@type": "Place",
      name: "Berlin, Germany",
    },
    member: [
      { "@type": "Person", name: "Sebastian Bucher", roleName: "Guitar, Vocals" },
      { "@type": "Person", name: "Hans-Joachim Bucher", roleName: "Drums, Percussion" },
      { "@type": "Person", name: "Robert Bucher", roleName: "Bass, Brass" },
    ],
    sameAs: [
      "https://soundcloud.com/user-33747841",
      "https://www.youtube.com/@thursdayjam",
    ],
    description: "Thursday Jam is a German family band from Berlin, playing soulful blues rock rooted in classic guitar music.",
  });

  return (
    <main id="main-content" className="relative">
      <PageFrame />
      <GrainOverlay />
      <Navigation />
      <Hero />
      <VinylPlayerSection />
      <Footer />
    </main>
  );
};

export default Index;
